import React from "react";
import { getRuntime } from "@next-core/runtime";
export function useRecentApps() {
  const [recentApps, setRecentApps] = React.useState(() => getRuntime().getRecentApps());
  React.useEffect(() => {
    const listener = event => {
      setRecentApps(event.detail);
    };
    window.addEventListener("app.change", listener);
    return () => window.removeEventListener("app.change", listener);
  }, []);
  return recentApps;
}
//# sourceMappingURL=useRecentApps.js.map